import { render, staticRenderFns } from "./PickupTab.vue?vue&type=template&id=1cc7b7ff"
import script from "./PickupTab.vue?vue&type=script&lang=js"
export * from "./PickupTab.vue?vue&type=script&lang=js"
import style0 from "./PickupTab.vue?vue&type=style&index=0&id=1cc7b7ff&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports